export enum UserPermission {
    ConsumptionOnLine = 1,
    ConsumptionOpenItems = 2,
    ConsumptionOffLine = 3,
    OnlineLabellingFull = 4,
    OnlineLabellingLimited = 5,
    OfflineLabelling = 6,
    PalletWhsManagement = 7,
    Admin = 8,
    Helpdesk = 9,
    Picking = 10,
    SuperAdmin = 11,
    JWOUser = 12,
    JWOAdmin = 13,
    DataCollection = 14,
    WOMadmin = 15,
    WOMLect = 16,
    PalEdit = 17,
    PalBlockResort = 18,
    PalBlockQI = 19,
    PalUnBlock = 20,
    PalReprint = 21,
    PalScrap = 22,
    PalDelete = 23,
    PalAddDefect = 24,
    ChangeCloseJob = 25,
    AssignNewJob = 26,
    PalApprove = 37,
    MassPalEdit = 38,
    MassPalAddDefect = 39,
    MassPalRemoveDefect = 40,
    MassPalBlockQI = 41,
    MassPalBlockResort = 42,
    MassPalUnBlock = 43,
    GlobalPermsAdmin = 44,
    LabellingQuantityEditable = 47,
    LabellingNoCopiesEditable = 48,
    LabellingQuantityLayersEditable = 49,
    PalVendorRet = 50,
    MerckPrint = 51,
}
